var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpulseLoading2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7717 1.2585C11.6307 1.1787 11.4576 1.1808 11.3184 1.2642L9 2.6553V6.3447L11.3187 7.7358C11.3898 7.7787 11.4696 7.8 11.55 7.8C11.6265 7.8 11.703 7.7805 11.7717 7.7415C11.9127 7.6617 12 7.5123 12 7.35V1.65C12 1.4877 11.9127 1.3383 11.7717 1.2585ZM6.45 0H1.95C0.873 0 0 0.873 0 1.95V7.05C0 8.127 0.873 9 1.95 9H6.45C7.527 9 8.4 8.127 8.4 7.05V1.95C8.4 0.873 7.527 0 6.45 0ZM4.2 6C3.3729 6 2.7 5.3271 2.7 4.5C2.7 3.6729 3.3729 3 4.2 3C5.0271 3 5.7 3.6729 5.7 4.5C5.7 5.3271 5.0271 6 4.2 6Z",
    fill: "#FDA29B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpulseLoading2);
export default __webpack_public_path__ + "static/media/epulse-loading2.990d4b6168f2a51cbd1a46306d13fba7ab9418d816e17c013439fc771cc7c2c1.svg";
export { ForwardRef as ReactComponent };